<template>
  <div class="row px-3">
    <div class="col-lg-1">
      <img :src="projectImage" class="project-logo mr-2" />
    </div>

    <div class="col-lg-11 col-sm-12 col-md-8 text-left mt-3 mt-lg-0 d-flex">
      <div class="row">
        <div class="col-12 text-left d-lg-flex justify-content-between">
          <div :class="project.Name ? 'mt-n1' : 'mt-1'">
            <h4 class="font-weight-bolder kova-text pointer mb-0" @click="goBid">
                {{ project.Title }}
            </h4>
            <span class=" text-capitalize" style="color: rgb(254, 152, 22);">
                {{ (project.Name || '').toLowerCase() }}
            </span>
          </div>

          <h5 class="font-weight-bolder kova-text" v-if="project.StartBudget">
            {{ project.Currency }}{{ formatAmount(project.StartBudget) }} - {{ project.Currency }}{{ formatAmount(project.EndBudget) }}
          </h5>
          <h5 class="font-weight-bolder kova-text" v-else-if="project.Budget">
            {{ project.Currency }}{{ formatAmount(project.Budget) }}
          </h5>
        </div>
        <div class="col-12 px-3 mt-2">
          <p class="text-size2 text-left" v-html="projectDescription"></p>
        </div>
        <div class="col-12 col-sm-12 col-lg-9 text-left">
          <div class="row mt-2">
            <div class="col-6">
              <h6
                class="font-weight-bolder ctrl-size-2 text-uppercase my-0 intermediate"
              >
                {{ computeExperienceLevel(project.Complexity) }}
              </h6>
              <p class="ctrl-size">Experience Level</p>
            </div>
            <div class="col-6">
              <h6 class="font-weight-bolder ctrl-size-2 mb-0">
                {{ project.Location || 'Not Specified' }}
              </h6>
              <p class="ctrl-size">
                <font-awesome-icon
                  style="font-size: 14px;"
                  icon="map-marker-alt"
                  class="text-dark mr-2"
                ></font-awesome-icon>
                Location</p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <h6 class="font-weight-bolder ctrl-size-2 mb-0">{{ hoursNeeded(project.Type) }}</h6>
              <p class="ctrl-size">Hours per week</p>
            </div>
            <div class="col">
              <h6 class="font-weight-bolder ctrl-size-2 mb-0">
                {{ computeDuration(project.Duration) }}
              </h6>
              <p class="ctrl-size">Duration</p>
            </div>
            <div class="col-3" v-if="project.Rate">
              <h6 class="font-weight-bolder ctrl-size-2 mb-0">{{ project.Rate || '$26/hr' }}</h6>
              <p class="ctrl-size">Hourly</p>
            </div>
          </div>
          <p class="text-left font-weight-bolder ctrl-size my-0">
            <span class=" kova-green mr-2"
              ><font-awesome-icon class="ctrl-size mr-2" icon="gavel" />{{
                project.TotalBids
              }} bids</span
            ><font-awesome-icon class="ctrl-size" icon="tag" v-if="project.Skills" />
            <span class="text-capitalize" v-if="project.Skills">
              {{ (project.Skills).join(', ') }}
            </span>
          </p>
          <p class="text-left font-weight-bolder ctrl-size mb-1">
            <font-awesome-icon class="ctrl-size" icon="clock" />
            {{ calcTime(project.CreatedAt) }}
          </p>
        </div>

        <div
          class="pl-lg-4 mt-3 mt-md-0 col-lg-3 col-sm-12"
        >
          <div class="pt-0 mt-0 mt-md-5 pt-md-5 text-right">
            <template v-if="status==='browse'">
              <button
                @click="toggleSaved(project.ID, !isSaved)"
                class="border-0 bg-transparent mt-3 mr-1"
              >
                <font-awesome-icon
                  style="font-size: 20px"
                  :style="{color: bookmarkColor}"
                  icon="bookmark"
                />
              </button>
              <button
                class="btn-kovatek py-3 py-lg-2 px-5 px-lg-4 add-rounded"
                @click="goBid"
              >
                Apply
              </button>
            </template>

            <button
              disabled
              v-if="status==='applied'"
              class="py-3 py-lg-2 px-5 px-lg-4 add-rounded"
            >
              Applied
            </button>

            <button
              v-else-if="status==='saved'"
              class="py-3 py-lg-2 px-5 px-lg-4 add-rounded border-0 bg-transparent"
              @click="remove(project.ID)"
            >
              <font-awesome-icon
                class="icon-size mr-1 kova-text"
                icon="trash"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import useMoment from '@/helpers/moment.js';

export default {
  props: {
    project: Object,
    status: {
      type: String,
      default: 'browse'
    },
    isSaved: Boolean,
  },
  computed: {
    projectDescription() {
      const desc = this.project.Description;
      return desc.charAt(0).toUpperCase() + desc.substr(1);
    },
    projectImage() {
      return this.project.AvatarHref || this.companyLogo
    },
    bookmarkColor() {
      return this.isSaved ? '#FE9816' : 'rgb(108 107 107)';
    }
  },
  methods: {
    calcTime(date) {
      return useMoment(date);
    },
    goBid() {
      this.$router.push(`job-details?projectId=${this.project.ID}`);
    },
    remove(id) {
      const vm = this;

      this.$confirm({
        title: 'Are you sure?',
        content: 'You are removing this job from your list!',
        async onOk() {
          return await deleteSavedJob();
        },
        onCancel() {},
      });

      async function deleteSavedJob() {
        const token = localStorage.getItem('token');
        vm.loading = true;

        try {
          await vm.$api({
            url: `/projects/${id}/save?status=0`,
            method: 'post',
            data: {},
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          await vm.$emit('update');

          vm.showNotification('success', 'This job has been removed from the list!', 'Successful');

          vm.loading = false;
        } catch (err) {
          vm.loading = false;
          vm.catchErrors(err)
        }
      }
    },
    toggleSaved(id, saved) {
      const vm = this;

      const content = saved ? 'You are adding this job to your saved list!' : 'You are removing this job from your list!';

      this.$confirm({
        title: 'Are you sure?',
        content,
        async onOk() {
          return await saveJob();
        },
        onCancel() {},
      });

      async function saveJob() {
        const token = localStorage.getItem('token');
        vm.loading = true;

        try {
          const res = await vm.$api({
            url: `/projects/${id}/save?status=${Number(saved)}`,
            method: 'post',
            data: {},
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if(res.status) {
            await vm.$emit('refresh-profile');

            const text = saved ? 'This job has been added to your list!' : 'This job has been removed from the list!';
            vm.showNotification('success', text, 'Successful');
            vm.loading = false;
          }
        } catch (err) {
          vm.loading = false;
          vm.catchErrors(err)
        }
      }
    }
  },
};
</script>